import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'ease-in-out', 'EaseInOut', [["path",{"d":"M3 20c8 0 10 -16 18 -16"}]]);